import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuthContext } from "./authContext";

const UtiContext = createContext();

const UtiProvider = ({ children }) => {
    const [IDOperadorLogado, setIDOperadorLogado] = useState(0);
    const [nomeOperador, setNomeOperador] = useState("");
    const { user } = useAuthContext();

    useEffect(() => {
        if (user) {
            setIDOperadorLogado(user.IDOperador || 0);
            setNomeOperador(user.nome || "");
        } else {
            setIDOperadorLogado(0);
            setNomeOperador("");
        }
    }, [user]);

    const resetaVariaveis = () => {
        setIDOperadorLogado(0);
        setNomeOperador("");
    };

    const logout = () => {
        resetaVariaveis();
    };

    return (
        <UtiContext.Provider value={{
            IDOperadorLogado,
            nomeOperador,
            setIDOperadorLogado,
            setNomeOperador,
            resetaVariaveis,
            logout
        }}>
            {children}
        </UtiContext.Provider>
    );
};

const useUtiContext = () => useContext(UtiContext);

export { UtiProvider, useUtiContext };
